import axios from 'axios';
import type { LimitsMap, GatesMap, Context, TiersMap } from '../types';

function getAllowancesUrl(context: Context) {
  return `/api/allowances/${context.type}/${context.id}`;
}

function getTiersUrl(context: Context) {
  return `/api/allowances/${context.type}/${context.id}/gates/tiers`;
}

export interface AllowancesResponse {
  gates: GatesMap;
  limits: LimitsMap;
  success: boolean;
}

export async function getAllowances(context: Context): Promise<AllowancesResponse> {
  const response = await axios.get<AllowancesResponse>(getAllowancesUrl(context));
  if (!response.data.success) {
    throw new Error('Failed to get allowances');
  }
  return response.data;
}

export interface TiersResponse {
  gates: TiersMap;
  success: boolean;
}

export async function getTiers(context: Context): Promise<TiersResponse> {
  const response = await axios.get<TiersResponse>(getTiersUrl(context));
  if (!response.data.success) {
    throw new Error('Failed to get tiers');
  }

  return response.data;
}
